import { BsFillWrenchAdjustableCircleFill } from 'react-icons/bs';
import { SiGoogleads } from 'react-icons/si';

export default function OAuthIcon({ credential }) {
  return <div
    className='text-center rounded-circle'
    style={{
      width: '50px',
      height: '50px',
    }}
  >
    {credential ? <SiGoogleads size='lg' /> : <BsFillWrenchAdjustableCircleFill size='lg' />}
  </div>
}
